import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'jsx!Component/I18n';
import DateTime from 'jsx!Component/DateTime';

function getItem(label, values) {
  let value = values[label.name];
  if (value === undefined) {
    return null;
  }

  if (label.type === 'DateTime') {
    return <span><DateTime ts={parseInt(value, 10)}/></span>;
  }
  if (label.type === 'TradeCmd') {
    return <span><I18n message={"tradeCmd." + value}/></span>;
  }

  return <span>{value}</span>;
}

function DictView(props) {
  let items = [];
  let labels = props.labels ? props.labels.slice() : [];

  if (!props.labels) {
    for (let key in props.value) {
      if (props.value.hasOwnProperty(key)) {
        labels.push({label: key, name: key});
      }
    }
  }

  for (let i = 0; i < labels.length;) {
    let tds = [];
    let rowStart = i;

    for (let col = 0; col < props.cols; col++) {
      if (i >= labels.length) {
        break;
      }

      let label = labels[i];
      let item = getItem(label, props.value);
      i++;

      if (item == null) {
        col--;
        continue;
      }

      tds.push(<td key={`${rowStart}-${col}-label`}><I18n message={label.label}/></td>);
      tds.push(<td key={`${rowStart}-${col}-item`}>{item}</td>);
    }

    items.push(<tr key={rowStart}>{tds}</tr>);
  }

  return (
    <table className="key_value">
      <tbody>
      {items}
      </tbody>
    </table>
  );
}

DictView.defaultProps = {
  value: {}
};

DictView.propTypes = {
  disabled: PropTypes.bool
};

export default DictView;



// WEBPACK FOOTER //
// ./src/js/Component/DictView.jsx